import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const tabIndicatorLineFn = /* @__PURE__ */ createRecipe('rp-tab-indicator-line', {}, [])

const tabIndicatorLineVariantMap = {}

const tabIndicatorLineVariantKeys = Object.keys(tabIndicatorLineVariantMap)

export const tabIndicatorLine = /* @__PURE__ */ Object.assign(memo(tabIndicatorLineFn), {
  __recipe__: true,
  __name__: 'tabIndicatorLine',
  raw: (props) => props,
  variantKeys: tabIndicatorLineVariantKeys,
  variantMap: tabIndicatorLineVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, tabIndicatorLineVariantKeys)
  },
})